import type { ScreenDef } from './types';

export const notesActivitiesFields: ScreenDef = {
    image: 'Notes & Activities',
    sections: [
        {
            name: 'Activities',
            entity: 'activitypointer',
            columns: [
                { field: 'subject' },
                { field: 'activitytypecode' },
                { field: 'statecode' },
                { field: 'ownerid' },
                { field: 'scheduledstart' },
            ],
        },
        {
            name: 'Timeline',
            entity: 'annotation',
            columns: [
                { field: 'modifiedon' },
                { field: 'modifiedby.fullname', labelOverride: 'Modified by' },
                { field: 'subject' },
                { field: 'notetext', labelOverride: 'Note' },
            ],
        },
    ],
};
